import { render, staticRenderFns } from "./cabinet-commercial-notice-card-contract-button.vue?vue&type=template&id=10cd1f4a&"
import script from "./cabinet-commercial-notice-card-contract-button.vue?vue&type=script&lang=js&"
export * from "./cabinet-commercial-notice-card-contract-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10cd1f4a')) {
      api.createRecord('10cd1f4a', component.options)
    } else {
      api.reload('10cd1f4a', component.options)
    }
    module.hot.accept("./cabinet-commercial-notice-card-contract-button.vue?vue&type=template&id=10cd1f4a&", function () {
      api.rerender('10cd1f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/commercial/cards/partials/cabinet-commercial-notice-card-contract-button.vue"
export default component.exports